export default function PreparationItemCategoriesController(
  $filter,
  $scope,
  $timeout,
  alerts,
  amDataService,
  amSharedModelService,
  editPreparationItemCategoryDialog,
  loaderService,
  ssDialogService,
) {
  const vm = this;

  // Attach Event Handlers
  vm.handleExpandPreparationItemCategories = _handleExpandPreparationItemCategories;
  vm.handleAddPreparationItemCategory = _handleAddPreparationItemCategory;
  vm.handleCreatePackageFileList = _handleCreatePackageFileList;
  vm.handleGeneratePackage = _handleGeneratePackage;
  vm.handleDownloadPackage = _handleDownloadPackage;
  vm.handleImportedPreparationItemCategories = _handleImportedPreparationItemCategories;

  _init();

  /** **********************************************
   * Event Handlers
   */

  function _handleExpandPreparationItemCategories() {
    if (!vm.isExpanded) {
      _loadPreparationItemCategories().then(() => {
        vm.isExpanded = true;
      });
    } else {
      vm.isExpanded = false;
    }
  }

  function _handleImportedPreparationItemCategories() {
    // TODO: importDocumentDialog should return preparationItemCategories model collection, then append instead of fetch
    _loadPreparationItemCategories(true);
  }

  function _handleAddPreparationItemCategory($event) {
    ssDialogService.dialogs.auditTrail.editPreparationItemCategoryDialog = ssDialogService.alert(
      editPreparationItemCategoryDialog.getOptions($event, {
        customerId: vm.customerId,
        preparationItemCategory: {
          auditId: vm.auditId,
          preparationItemCategoryId: 0,
        },
      }),
    );
    return ssDialogService.show(ssDialogService.dialogs.auditTrail.editPreparationItemCategoryDialog);
  }

  function _handleCreatePackageFileList() {
    return amDataService.generatePreparationItemPackageFileList(vm.auditId).then(() => {
      alerts.success('The Preparation Item File List has been successfully generated. '
        + 'Please run the Audit Package File List Report to view the results.');
    });
  }

  function _handleGeneratePackage() {
    return amDataService.createPreparationItemPackageFileGenerationRequest(vm.auditId).then(() => {
      alerts.success('The Preparation Item Package has been successfully requested. '
        + 'You will receive an email notification when the file generation is complete.');
      vm.hasAuditPackageGenerationRequests = true;
    });
  }

  function _handleDownloadPackage() {
    alerts.success('Download Package has been requested. Package download will start momentarily.');
    amDataService.downloadPackage(vm.auditPackageId).then((packageResponse) => {
      amDataService.download(packageResponse);
    });
  }

  /** **********************************************
   * Private Functions
   */

  function _init() {
    vm.canExpand = true;
    vm.isExpanded = false;
    vm.hasData = false;
    vm.canEditItem = vm.canEdit && vm.auditIsActive;
    vm.canDeleteItem = vm.canDelete && vm.auditIsActive;
    vm.canGenerateItemPackage = vm.canGeneratePackage && vm.auditIsActive;
    vm.canDownloadItemPackage = vm.canDownloadPackage && vm.hasActiveAuditPackage;
    _initEventListeners();
  }

  function _initEventListeners() {
    $scope.$on('refreshAMPreparationItemCategories', (event, opt) => {
      if (opt.auditId === vm.auditId) {
        _loadPreparationItemCategories(true);
      }
    });
  }

  function _setNoItemMessage() {
    if (vm.preparationItemCategories.length === 0) {
      vm.noItemMessage = 'There are currently no Preparation Items for you to contribute to in this Audit.';
    } else {
      vm.noItemMessage = 'There are no Preparation Items yet. Please import or add Preparation Items.';
    }
  }

  function _loadPreparationItemCategories(forceRefresh = false) {
    loaderService.showViewLoader = true;
    return amSharedModelService.getPreparationItemCategories(vm.auditId, forceRefresh)
      .then((preparationItemCategories) => {
        loaderService.showViewLoader = false;
        vm.preparationItemCategories = preparationItemCategories;
        _setNoItemMessage();
      });
  }
}

PreparationItemCategoriesController.$inject = [
  '$filter',
  '$scope',
  '$timeout',
  'alerts',
  'amDataService',
  'amSharedModelService',
  'editPreparationItemCategoryDialog',
  'loaderService',
  'ssDialogService',
];
